import { useEffect, createContext, useState, useContext } from "react";
import { useWeb3Context } from "web3-react";
import { firestore } from "../firebase";
import { doc, getDocs, getDoc } from "firebase/firestore";

const UserDocContext = createContext();

export const UserDocProvider = ({ children }) => {
  const [docData, setDocData] = useState();
  const { account } = useWeb3Context();

  useEffect(() => {
    const getDocData = async () => {
      const docToProcess = await doc(firestore, "users", account);
      // console.log("docToProcess :", docToProcess);

      setDocData(docToProcess);
    };
    if (!(account === undefined)) {
      getDocData();
    }
  }, [account]);

  return (
    <UserDocContext.Provider value={{ docData }}>
      {children}
    </UserDocContext.Provider>
  );
};

export const UseUserDocContext = () => {
  const context = useContext(UserDocContext);
  if (context === undefined) {
    throw new Error("useUserDocContext must be used within a UserDocProvider");
  }
  return context;
};
